function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.18029 13.8808C2.18029 14.1787 2.42353 14.4225 2.72083 14.4225H14.6127C14.91 14.4225 15.1533 14.1787 15.1533 13.8808V5.13688H2.18029V13.8808ZM8.2024 4.20838H2.16669L3.46398 1.91984C3.66669 1.64901 3.9775 1.50005 4.31534 1.50005H8.2024V4.20838ZM15.1667 4.20838L9.13097 4.20833V1.5L13.018 1.50005C13.3559 1.50005 13.6667 1.66255 13.8694 1.91984L15.1667 4.20838ZM7.2382 11.6012C7.2382 11.3448 7.44607 11.1369 7.70249 11.1369H12.3453C12.6018 11.1369 12.8096 11.3448 12.8096 11.6012C12.8096 11.8576 12.6018 12.0655 12.3453 12.0655H7.70249C7.44607 12.0655 7.2382 11.8576 7.2382 11.6012ZM9.55963 9.27975C9.30321 9.27975 9.09535 9.48762 9.09535 9.74404C9.09535 10.0005 9.30321 10.2083 9.55963 10.2083H12.3453C12.6018 10.2083 12.8096 10.0005 12.8096 9.74404C12.8096 9.48762 12.6018 9.27975 12.3453 9.27975H9.55963Z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/stepPicked.40d9cb73.svg";
export { SvgComponent as ReactComponent };